export enum HandStatus {
  Raised = 'raised',
  Lowered = 'lowered',
  Accepted = 'accepted',
  Declined = 'declined',
  Revoked = 'revoked',
  Invited = 'invited',
}
